import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      return;
    }
    if (!email.trim()) return;
    setStatus('submitting');
    try {
      const formData = new FormData();
      formData.append('email', email.trim());
      const urlEncoded = new URLSearchParams();
      formData.forEach((value, key) => {
        urlEncoded.append(key, value as string);
      });
      await fetch('https://readdy.ai/api/form/d90kmck6ci2plld1oehg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: urlEncoded.toString(),
      });
      setStatus('success');
      setEmail('');
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="py-14 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20warm%20abstract%20background%20with%20soft%20amber%20and%20gold%20gradient%20waves%2C%20modern%20minimal%20design%2C%20elegant%20flowing%20geometric%20shapes%2C%20cinematic%20atmosphere%2C%20luxurious%20dark%20texture%2C%20subtle%20glow%20effects%2C%20clean%20composition&width=1600&height=600&seq=newsletter-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-foreground-950/75"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8 md:gap-12">
          <div className="lg:max-w-md text-center lg:text-left">
            <div className="flex items-center justify-center lg:justify-start gap-2 mb-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500/90">
                <i className="ri-mail-unread-line text-background-50 text-sm"></i>
              </div>
              <span className="text-xs font-semibold text-accent-400 uppercase tracking-widest">
                Newsletter
              </span>
            </div>

            <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-3">
              不想错过任何猛料？
            </h2>
            <p className="text-sm md:text-base text-background-50/70 leading-relaxed">
              订阅吃瓜网 Newsletter，每周精选最劲爆的瓜直接送到你邮箱。明星塌房、网红黑料、反差视频，一个都不会漏。
            </p>

            <div className="hidden lg:flex items-center gap-6 mt-6">
              <div className="flex items-center gap-2">
                <span className="text-2xl font-bold text-accent-400 font-heading">128万+</span>
                <span className="text-xs text-background-50/50">订阅用户</span>
              </div>
              <div className="w-px h-8 bg-background-50/15"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl font-bold text-accent-400 font-heading">0</span>
                <span className="text-xs text-background-50/50">垃圾邮件</span>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[440px]">
            <div className="bg-background-50/10 backdrop-blur-md rounded-2xl p-6 md:p-8 border border-background-50/10">
              <form onSubmit={handleSubmit} data-readdy-form="" className="space-y-4">
                <div>
                  <label htmlFor="nl-email" className="block text-xs font-medium text-background-50/70 mb-1.5">
                    邮箱地址 <span className="text-accent-400">*</span>
                  </label>
                  <div className="flex gap-2">
                    <input
                      type="email"
                      id="nl-email"
                      name="email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="flex-1 px-4 py-2.5 text-sm bg-background-50/90 border border-background-50/20 rounded-full focus:outline-none focus:ring-2 focus:ring-accent-400 focus:border-accent-400 transition-all text-foreground-900 placeholder:text-foreground-400"
                      placeholder="your@email.com"
                    />
                    <button
                      type="submit"
                      disabled={status === 'submitting'}
                      className="px-6 py-2.5 bg-accent-500 hover:bg-accent-600 disabled:bg-accent-400/50 text-background-50 font-medium text-sm rounded-full transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {status === 'submitting' ? (
                        <i className="ri-loader-4-line animate-spin"></i>
                      ) : (
                        '订阅'
                      )}
                    </button>
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id="nl-agree"
                    required
                    className="w-4 h-4 rounded border-background-50/30 text-accent-500 focus:ring-accent-400 cursor-pointer"
                  />
                  <label htmlFor="nl-agree" className="text-xs text-background-50/60 cursor-pointer">
                    我同意接收吃瓜网的邮件推送，并已阅读
                    <a href="/about#privacy" className="text-accent-400 hover:text-accent-300 underline ml-0.5">隐私政策</a>
                  </label>
                </div>

                <div style={{ position: 'absolute', left: '-9999px', opacity: 0 }} aria-hidden="true">
                  <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" />
                </div>

                {status === 'success' && (
                  <div className="p-3 rounded-lg bg-accent-500/20 text-accent-300 text-sm text-center border border-accent-500/30">
                    <i className="ri-check-double-line mr-1.5"></i>
                    订阅成功！猛料即将送达你的邮箱
                  </div>
                )}

                {status === 'error' && (
                  <div className="p-3 rounded-lg bg-accent-500/10 text-accent-300 text-sm text-center">
                    订阅失败，请稍后重试
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
